// Polyfills
import './polyfills/append';
import './polyfills/fill';

// Selectors
import appendPlaceholderToSelect from './selectors/appendPlaceholderToSelect';

// Utilities
import dayjs from 'dayjs';
import * as I18n from './leadform-i18n';

// VT is open weekdays from 7am - 10pm Central
// 7am to 8pm Central on weekends
// This code assumes our visitors are located in North America
export const weekdayHours = [8, 20]; // 8am to 8pm local
export const weekendHours = [10, 18]; // 10am to 6pm local
export const todayString = I18n.translateKey('leadform.times.today');
export const holidayHours = {
  '20191127': [8, 15], // day before Thanksgiving
  '20191128': [] // Thanksgiving day
};

function canSetupCallBackScheduling(){
  const dateField = document.querySelector('select[name="day_to_call"]');
  const timeField = document.querySelector('select[name="time_to_call"]');
  return (dateField !== null && timeField !== null);
}


// Sets up the callback scheduling fields in the form
export function setupCallbackScheduling(){
  if (canSetupCallBackScheduling() == false){
    return;
  }
  const firstClientTime = nextAvailableHour();
  const availableDates = buildDates(firstClientTime);
  const availableTimes = buildTimes(firstClientTime);

  updateDateField(availableDates);
  updateTimeField(availableTimes);

  const dateField = document.querySelector('select[name="day_to_call"]');
  dateField.addEventListener('change', function(e) {
      exports.updateTimes(e.target.value);
  });
}

export function nextAvailableHour(){
  return exports.currentTime().add('90', 'minute').startOf('hour');
}

export function currentTime(){
  return dayjs();
}

// Updates the available date options in the form
export function updateDateField(availableDates){
  const dateField = document.querySelector('select[name="day_to_call"]');
  const now = exports.currentTime();
  removeChildren(dateField);

  appendPlaceholderToSelect(dateField, I18n.translateKey(
    'leadform.select_options.placeholder'));

  for (const availableDate of availableDates) {
    const dateLabel = now.isSame(availableDate, 'day')
      ? todayString
      : availableDate.format('ddd, MMM D');
    const option = document.createElement('option');
    option.setAttribute('value', availableDate.format());
    option.innerHTML = dateLabel;

    dateField.appendChild(option);
  }
  const anytime = document.createElement('option');
  anytime.innerHTML = I18n.translateKey('leadform.times.anytime');
  anytime.setAttribute('data-target', '');
  anytime.setAttribute('value', 'anytime');
  dateField.append(anytime);
}

// Updates the available time options in the form
export function updateTimeField(availableTimes){
  const timeField = document.querySelector('select[name="time_to_call"]');
  removeChildren(timeField);

  appendPlaceholderToSelect(timeField, I18n.translateKey(
    'leadform.select_options.placeholder'));

  if(availableTimes.length > 0) {
    for (var i = 0; i < availableTimes.length; i++) {
      const option = document.createElement('option');
      option.setAttribute('value', availableTimes[i].iso);
      option.innerHTML = availableTimes[i].display;
      timeField.appendChild(option);
    }
  } else {
    const option = document.createElement('option');
    option.setAttribute('value', 'default');
    option.setAttribute('disabled', true);
    option.setAttribute('hidden', true);
    option.setAttribute('selected', true);
    option.innerHTML = 'No times available';
    timeField.appendChild(option);
  }
}

// Updates the times in the leadform
export function updateTimes(timeString) {
  const dayMoment = dayjs(timeString);

  if (dayMoment.isValid() == false) {
    updateTimeField([]);
    return;
  }

  const firstClientTime = nextAvailableHour();
  const checkedDate = dayMoment.startOf('day');
  const today = firstClientTime.startOf('day');
  const isToday = checkedDate.isSame(today);
  const availableTimes = buildTimes(isToday ? firstClientTime : checkedDate);
  updateTimeField(availableTimes);
}

const startEndTime = function(momentObj, startOrEnd) {
  const targetDate = momentObj.clone().startOf('day');
  const i = startOrEnd === 'start' ? 0 : 1;
  let targetTime;
  if(holidayHours[targetDate.format('YYYYMMDD')]) {
    const hours = holidayHours[targetDate.format('YYYYMMDD')];
    targetTime = targetDate.add(hours[i], 'hour') || null;
  } else {
    targetTime = isWeekend(targetDate)
      ? targetDate.add(weekendHours[i], 'hour')
      : targetDate.add(weekdayHours[i], 'hour');
  }
  return targetTime;
};

export const numberOfDays = 3;

export function isWeekend(momentObj) {
  return [0, 6].indexOf(momentObj.day()) > -1;
}

export function fbusinessStartTime(momentObj) {
  return startEndTime(momentObj, 'start');
}

export function fbusinessEndTime(momentObj) {
  return startEndTime(momentObj, 'end');
}

// Builds a list of dates from the current date forward
export function buildDates(startDateObj, qty = numberOfDays) {
  return Array(qty).fill().map((_, i) => startDateObj.clone().startOf('day').add(i, 'day'));
}

// Removes all children from a dom element
export function removeChildren(elem) {
  while (elem.firstChild) {
      elem.removeChild(elem.firstChild);
  }
}

// returns an array of availabletime objects
// diplay: friendly time, iso: iso8601 string with offset
// [{ display: '9:00 AM', iso: '2019-11-22T09:00:00-10:00' }]
export function buildTimes(targetDateObj) {
  const availableTimes = [];
  const businessStartTime = fbusinessStartTime(targetDateObj);
  const businessEndTime = fbusinessEndTime(targetDateObj);
  if (businessStartTime && businessEndTime) {
    const startTime = targetDateObj > businessStartTime
      ? targetDateObj
      : businessStartTime;
    for (var i = startTime.clone(); i < businessEndTime; ) {
      const availableTime = { display: i.format('h:mm A'), iso: i.toISOString() };
      availableTimes.push(availableTime);
      i = i.add('30', 'minute');
    }
  }
  return availableTimes;
}
